<template>
  <v-container
    fluid
    class="main-container">
    <div class="px-4">
      <v-row>
        <v-toolbar
          flat
          color="transparent">
          <v-spacer></v-spacer>
          <v-toolbar-title class="score-title pl-4 text-uppercase">Action Plan</v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="500">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ My 50+ life design Index</div>
            </v-card-title>
            <v-chart
              :options="scoreRadar"
              autoresize
              ref="chart"></v-chart>
          </v-card>
        </v-col>
        <v-col cols="">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="500">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Vision</div>
              <div class="section-title-borx`der"></div>
            </v-card-title>
            <v-list
              class="pa-0 listing"
              dense
              color="transparent">
              <v-list-item>
                <v-list-item-subtitle>내가 생각하는 행복한 삶이란?</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title class="text-right">{{ (this.master['Master-openEnded-2'] || {}).value || '' }}삶이다</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            :rounded="false"
            color="blue lighten-4"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="500">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Career</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              color="transparent"
              class="pa-0 listing"
              dense>
              <v-list-item
                v-for="(v, i) in action['액션플랜-Career'].value"
                :key="'career' + i"
                class="pa-0">
                <v-list-item-subtitle style="flex-basis: 80%">해야 할일 {{ i + 1 }}</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold text-right">{{ v.value }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            :rounded="false"
            color="teal lighten-4"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="500">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Finance</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              color="transparent"
              class="pa-0 listing"
              dense>
              <v-list-item
                v-for="(v, i) in action['액션플랜-Finance'].value"
                :key="'finance' + i"
                class="pa-0">
                <v-list-item-subtitle style="flex-basis: 80%; font-size: 12px">해야 할일 {{ i + 1 }}</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold text-right">{{ v.value }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="520">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ 생애 이슈</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              class="pa-0 listing"
              dense>
              <v-list-item>
                <v-list-item-subtitle>은퇴 크레바스는?</v-list-item-subtitle>
                <v-list-item-title
                  style="flex-basis: 80%"
                  class="font-weight-bold text-right"
                  >{{ crevasseAge }}</v-list-item-title
                >
              </v-list-item>
              <v-list-item>
                <v-list-item-subtitle>Event 목적자금 우선순위는?</v-list-item-subtitle>
              </v-list-item>
              <v-list-item
                class=""
                v-for="(m, i) in getFinanceGoalMoney"
                :key="m.title">
                <v-list-item-title>{{ `${i + 1}순위 - ${m.title}` }}</v-list-item-title>
                <v-list-item-title
                  style="flex-basis: 80%"
                  class="font-weight-bold text-right"
                  >{{ `${m.money} 백만원` }}</v-list-item-title
                >
              </v-list-item>
              <v-list-item>
                <v-list-item-subtitle>2nd Life Risk 보장중 부족한 영역은?</v-list-item-subtitle>
              </v-list-item>
              <v-list-item
                class=""
                v-for="(m, i) in finance['재무-리스크'].value.filter((o) => !o.value)"
                :key="m.title">
                <v-list-item-title></v-list-item-title>
                <v-list-item-title
                  style="flex-basis: 80%"
                  class="font-weight-bold text-right"
                  >{{ ` ${m.text.split(/\s/g)[0]}` }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            :rounded="false"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="520">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Career 이슈</div>
            </v-card-title>
            <v-list
              class="pa-0 listing"
              dense>
              <v-list-item class="pa-0">
                <v-list-item-subtitle>일로부터 완전한 은퇴시기는?</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pl-12">
                <v-list-item-title class="font-weight-bold text-right">{{ career['커리어-완전은퇴'].value }}세</v-list-item-title>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-subtitle>주 직장 이후 고려 가능한 직업은?</v-list-item-subtitle>
              </v-list-item>
              <v-list-item
                class="pl-12"
                v-for="v in career['커리어-퇴근후직업'].value"
                :key="'cc' + v.value">
                <v-list-item-title class="font-weight-bold text-right">{{ v.value }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col>
          <v-card
            :rounded="false"
            color="lime lighten-4"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="520">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Health</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              class="pa-0 listing"
              dense>
              <v-list-item
                v-for="(v, i) in action['액션플랜-Health'].value"
                :key="'health' + i"
                class="pa-0">
                <v-list-item-subtitle style="flex-basis: 80%">해야 할일 {{ i + 1 }}</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold text-right">{{ v.value }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col>
          <v-card
            :rounded="false"
            color="orange lighten-4"
            class="pa-5"
            elevation="1"
            style="border: 1px solid #d3eff8"
            height="520">
            <v-card-title class="justify-space-between pa-0">
              <div class="section-title title-kor">+ Network</div>
              <div class="section-title-border"></div>
            </v-card-title>
            <v-list
              class="pa-0 listing"
              dense>
              <v-list-item
                v-for="(v, i) in action['액션플랜-Network'].value"
                :key="'network' + i"
                class="pa-0">
                <v-list-item-subtitle style="flex-basis: 80%">해야 할일 {{ i + 1 }}</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold text-right">{{ v.value }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import { mapMutations, mapState, mapGetters } from 'vuex'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
export default {
  components: {
    'v-chart': ECharts,
  },
  mounted() {
    this.drawChart()
  },
  data() {
    return {
      icon: {
        Finance: 'mdi-finance',
        Master: 'mdi-telegram',
        Career: 'mdi-briefcase',
        Life: 'mdi-home-city-outline',
      },
      관계: 'mdi-handshake',
      커리어: 'mdi-briefcase',
      건강: 'mdi-hospital-box',
      재무: 'mdi-cash-usd-outline',
      opt: {
        grid: {
          width: '80%',
          left: '18%',
          hegith: '100%',
        },
      },
      scoreRadar: {
        // title: {
        //   text: '能力雷达图',
        // },
        tooltip: {},
        radar: {
          startAngle: 90,
          splitNumber: 3,
          shape: 'circle',
          name: {
            formatter: '{value}',
            textStyle: {
              color: '#757575',
              fontSize: 14,
              fontWeight: 'bold',
            },
          },
          splitArea: {
            areaStyle: {
              color: ['rgba(255, 255, 255, 0.2)', 'rgba(255, 255, 255, 0.4)', 'rgba(255, 255, 255, 0.6)'],
              // color: ['rgba(114, 172, 209, 0.2)', 'rgba(114, 172, 209, 0.4)', 'rgba(114, 172, 209, 0.6)', 'rgba(114, 172, 209, 0.8)', 'rgba(114, 172, 209, 1)'],
              // shadowColor: 'rgba(0, 0, 0, 0.3)',
              // shadowBlur: 10,
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(122, 122, 122, 0.5)',
            },
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(122, 122, 122, 0.5)',
            },
          },

          radius: 120,
        },
        series: [
          {
            name: '',
            type: 'radar',
            data: [
              {
                value: [],
              },
            ],
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'career', 'action']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'exit']),
    cellLength() {
      const nintyAt = this.me.birthAt + 91
      // console.log(nintyAt, this.currentYear)
      return nintyAt - this.currentYear
      // return 40
    },
    crevasseAge() {
      const t = (this.exit[17] || []).slice(0)

      if (!t[0]) return '없음'
      else {
        const s = t.shift()
        const e = t.pop()

        if (!e) return '없음'
        else return s + '세부터 ' + e + '세까지'
      }
    },
  },
  methods: {
    drawChart() {
      const k = Object.keys(this.master).filter((k) => k.includes('likert'))
      const likertSheet = k.map((k) => this.master[k])
      const sum = likertSheet.reduce((a, c) => {
        if (!a[c.subCategory]) {
          a[c.subCategory] = c.value
        } else a[c.subCategory] += c.value
        return a
      }, {})
      this.scoreSheet = [sum['관계'], sum['재무'], sum['커리어'], sum['건강']]

      const ss = Object.keys(sum).map((k) => ({ subCategory: k, value: sum[k] }))
      const so = _.orderBy(ss, ['value'], ['desc'])
      this.high = so[0].subCategory
      this.highScore = so[0].value
      this.low = so[3].subCategory
      this.lowScore = so[3].value
      // console.log(likertSheet)

      const rk = _.orderBy(likertSheet, ['value'], ['desc']).map((o) => ({
        icon: this[o.subCategory],
        text: o.summary,
      }))
      // console.log(rk)

      const rr = [].concat(rk.slice(0, 4)).concat(rk.slice(0).reverse().slice(0, 4))

      this.rankName = rr

      const opt = this.scoreRadar
      opt.radar.indicator = [
        { name: `관계(${this.scoreSheet[0]})`, max: 100 },
        { name: `재무(${this.scoreSheet[1]})`, max: 100 },
        { name: `커리어(${this.scoreSheet[2]})`, max: 100 },
        { name: `건강(${this.scoreSheet[3]})`, max: 100 },
      ]
      opt.series[0].data[0] = {
        value: this.scoreSheet,
        lineStyle: {
          type: 'solid',
          width: 0,
          color: 'rgba(182, 51, 50,1)',
        },

        areaStyle: {
          color: new ECharts.graphic.RadialGradient(0.5, 0.5, 1, [
            {
              color: '#E65100',
              offset: 0,
            },
            {
              color: '#FFCC80',
              offset: 1,
            },
          ]),
          // color: 'rgba(182, 51, 50, 0.5)',
          // color: 'rgba(251, 140, 0, 1, 1)',
        },
        label: {
          show: false,
          position: 'top',
          distance: 15,

          textStyle: {
            color: '#757575',
            fontSize: 18,
            fontWeight: 'bold',
          },

          formatter: function (params) {
            return params.name + ' ' + params.value
          },
        },
      }

      this.$refs.chart.mergeOptions(opt)
    },
  },
}
</script>

<style
  scoped
  lang="scss">
.listing div.v-list-item__subtitle {
  font-size: 16px !important;
}
.listing div.v-list-item__title {
  font-size: 18px !important;
}
.listing div.v-list-item > div {
  line-height: 18px !important;
}
.echarts {
  width: 100%;
  height: 100%;
}
.score {
  padding: 18px;
}
.life-top {
  font-size: 1em;
  border-bottom: 2px solid rgb(10, 8, 8);
}
.header-col {
  border-right: 1px solid black;
}
.life {
  text-align: center;
  min-height: 64px;
}
.life-footer {
}
// .echarts {
//   width: 100%;
//   height: 100%;
// }
.echarts {
  height: 400px;
  width: 100%;
}
.good {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.bad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid grey;
}
.happy-row {
  border-top: 1px solid grey;
}
</style>
